// extracted by mini-css-extract-plugin
export default {"page":"Page404_page__2RT8l","page__title":"Page404_page__title__++tYH"};